import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/deployment/deployer-menu.md?raw';

const DeploymentDeployerMenu: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default DeploymentDeployerMenu;
